import { ErrorHandler, NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { ApiModule, Configuration } from './generate-client';
import { AppConfig } from './helper/token-getter';
import { ComponentsModule } from './components/components.module';
import { NgxMercadopagoModule } from 'ngx-mercadopago';
import { JwtInterceptor } from './helper/jwt.interceptor';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    FormsModule,
    IonicModule.forRoot(),
    CommonModule,
    AppRoutingModule,
    ComponentsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ApiModule.forRoot(AppConfig),
    NgxMercadopagoModule.forRoot({
      publishKey: 'TEST-43720603-4dd9-41b0-a1af-c4e924ee6a7b',
      pathSDK: 'https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js'
    })
  ],
  providers: [
    Geolocation,
    NativeGeocoder,
    OneSignal,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
